import { UseQueryOptions, useQuery } from "@tanstack/react-query"
import { APIS_KEYS } from "../../apis-keys"
import {
	IPropsGetWheelhouseProperties,
	IResponseGetWheelhouseProperties,
} from "./types"
import { GetWheelhousePropertiesURL } from "../../../utils/constants"
import type { AxiosInstance, AxiosResponse } from "axios"
import { useApi } from "../../useApi"

async function getWheelhouseProperties(
	apiPrivate: AxiosInstance,
	{ searchKey }: IPropsGetWheelhouseProperties
) {
	try {
		const response: AxiosResponse<IResponseGetWheelhouseProperties> =
			await apiPrivate.get(`${GetWheelhousePropertiesURL}`, {
				params: {
					searchKey: searchKey,
				},
			})
		return response.data
	} catch (error: any) {
		console.log(error)
		throw new Error("something went wrong")
	}
}

export function useGetWheelhouseProperties(
	data: IPropsGetWheelhouseProperties,
	options?:
		| Omit<
				UseQueryOptions<
					IResponseGetWheelhouseProperties,
					unknown,
					IResponseGetWheelhouseProperties
				>,
				"queryKey" | "queryFn"
		  >
		| undefined
) {
	const { apiPrivate } = useApi()
	return useQuery({
		queryKey: [APIS_KEYS.GETWHEELHOUSEPROPERTIES, ...Object.values(data)],
		queryFn: () => getWheelhouseProperties(apiPrivate, data),
		...options,
	})
}
